import { MaterialInputAutoComplete } from "features/shared/presentation/components";
import {
  adminSettingsEditUserMaterialSupplierCustomer,
  selectAdminSettingsEditUserMaterialSupplierCustomer,
} from "../slices/admin-settings-edit-user-meterial-supplier-customer.slice";
import { useAppDispatch, useAppSelector } from "features/config/hooks";
import { useEffect, useState } from "react";
import { AdminSettingsEditUserEnrollCompanyModal } from "../modals/admin-settings-edit-user-enroll-company.modal";

interface AdminSettingsEditUserEnrollCompanyModalProps {
  company?: number | undefined | null;
  setCompany: (company: number) => void;
}
export function AdminSettingUserCompany(
  props: AdminSettingsEditUserEnrollCompanyModalProps
) {
  const dispatch = useAppDispatch();
  const adminSettingsEditUserMaterialSupplierCustomerState = useAppSelector(
    selectAdminSettingsEditUserMaterialSupplierCustomer
  );

  const [openCompanyEnrollment, setOpenCompanyEnrollment] = useState(false);

  useEffect(() => {
    if (!adminSettingsEditUserMaterialSupplierCustomerState.data) {
      dispatch(adminSettingsEditUserMaterialSupplierCustomer());
    }
  }, [adminSettingsEditUserMaterialSupplierCustomerState.data]);

  const value =
    adminSettingsEditUserMaterialSupplierCustomerState.data?.companies.find(
      (company) => company.id === props.company
    );

  return (
    <>
      <MaterialInputAutoComplete
        colorTheme={"black"}
        options={
          adminSettingsEditUserMaterialSupplierCustomerState.data?.companies ??
          []
        }
        value={adminSettingsEditUserMaterialSupplierCustomerState.data?.companies.find(
          (comp) => comp.id === props.company
        )}
        getOptionLabel={(option) => option.name}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        onChange={(evt, selectedOption) => {
          if (selectedOption) {
            props.setCompany(selectedOption.id);
          }
        }}
        required
        label="Company"
      />
      <div className="flex justify-end text-sm text-button text-[Roboto]">
        <button type="button" onClick={() => setOpenCompanyEnrollment(true)}>
          Enroll New Company
        </button>
      </div>

      <AdminSettingsEditUserEnrollCompanyModal
        open={openCompanyEnrollment}
        onClose={() => setOpenCompanyEnrollment(false)}
      />
    </>
  );
}
